import React, { memo, ReactNode } from 'react'
import tw from 'twin.macro'

interface Props {
  children: ReactNode
  /**
   * `end` (default) bottom-aligns the controls. Use `start` when a field can grow an error
   * message underneath, so the message extends the row downwards instead of lifting its input;
   * label-less controls then need their own `pt-6` to sit at input level.
   */
  align?: 'end' | 'start'
}

/** The filter row that sits between tabs and grid — same chrome as `ScheduledActionsToolbar`. */
const ToolbarRowComponent = ({ children, align = 'end' }: Props) => {
  return (
    <div
      css={[
        tw`flex shrink-0 flex-row flex-wrap gap-4 border-0 border-b border-t border-solid border-shades-100 bg-shades-0 px-4 py-3`,
        align === 'start' ? tw`items-start` : tw`items-end`,
      ]}
    >
      {children}
    </div>
  )
}

export const ToolbarRow = memo(ToolbarRowComponent)
